var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"print"},[_c('avue-crud',{ref:"crud",attrs:{"data":_vm.tableData,"table-loading":_vm.tableLoading,"option":_vm.tableOption},scopedSlots:_vm._u([{key:"index",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.$index + 1))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }